__turbopack_context__.v({
  "cluster": "hero-module__oUwnQa__cluster",
  "contactButton": "hero-module__oUwnQa__contactButton",
  "content": "hero-module__oUwnQa__content",
  "copy": "hero-module__oUwnQa__copy",
  "cta": "hero-module__oUwnQa__cta",
  "ctaWrap": "hero-module__oUwnQa__ctaWrap",
  "eyebrow": "hero-module__oUwnQa__eyebrow",
  "headline": "hero-module__oUwnQa__headline",
  "headlineHighlight": "hero-module__oUwnQa__headlineHighlight",
  "headlineLine": "hero-module__oUwnQa__headlineLine",
  "hero": "hero-module__oUwnQa__hero",
  "mainContainer": "hero-module__oUwnQa__mainContainer",
  "mainHeading": "hero-module__oUwnQa__mainHeading",
  "mainText": "hero-module__oUwnQa__mainText",
  "mainTextContainer": "hero-module__oUwnQa__mainTextContainer",
  "overlay": "hero-module__oUwnQa__overlay",
  "secondaryContainer": "hero-module__oUwnQa__secondaryContainer",
  "secondaryHeading": "hero-module__oUwnQa__secondaryHeading",
  "secondaryTextContainer": "hero-module__oUwnQa__secondaryTextContainer",
  "stage": "hero-module__oUwnQa__stage",
  "subtitle": "hero-module__oUwnQa__subtitle",
  "videoEmbed": "hero-module__oUwnQa__videoEmbed",
  "word": "hero-module__oUwnQa__word",
  "wordLtr": "hero-module__oUwnQa__wordLtr",
});
